import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-defaultIcon",
  "use": "rt-base-defaultIcon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-defaultIcon\"><defs><style type=\"text/css\"></style></defs><path d=\"M848 80H178c-35.2 0-64 28.8-64 64v736c0 35.2 28.8 64 64 64h538c107.8 0 196-88.2 196-196V144c0-35.2-28.8-64-64-64zM352 288h210c22 0 40 18 40 40s-18 40-40 40H352c-22 0-40-18-40-40s18-40 40-40z m100 447H352c-22 0-40-18-40-40s18-40 40-40h100c22 0 40 18 40 40s-18 40-40 40z m220-183H352c-22 0-40-18-40-40s18-40 40-40h320c22 0 40 18 40 40s-18 40-40 40z\" p-id=\"2564\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/defaultIcon.svg
// module id = 1260
// module chunks = 72